<div class="form-holder">
  <div class="safe-area">
    <h1 *ngIf="description != ' '" class="objective" [innerHTML]="common.replaceURLs(description)"></h1>
    <h1 class="objective" [innerHTML]="common.replaceURLs(sharedLinks)"></h1>
    <div *ngIf="isLive && !hideTop" class="rejoin-holder">
        <span class="status">{{'POLL-ONGOING.TITLE' | translate}}</span>
        <div class="button-container">
          <button class="blue-button" style="margin-top: 3px;" *ngIf="type == 'liveCandidates' || type == 'election' && isLive" (click)=rejoin() data-cy="return-to-election-btn">{{'POLL-ONGOING.REJOIN-ELECTION' | translate}}</button>
          <button class="blue-button" style="margin-top: 3px;" *ngIf="type == 'live' || type == 'resolution' && isLive" (click)=rejoin() data-cy="return-to-election-btn">{{'POLL-ONGOING.REJOIN-RESOLUTION' | translate}}</button>
        </div>
        <div style="width: 126px"></div>
    </div>
    <div class="separator"></div>
    <div class="infos-holder">
      <div class="small-holder" style="width: 165px">
        <img class="description-icon" src="assets/calendar-small.svg">
        <div>
          <h3 class="descriptor">{{'POLL-ONGOING.START' | translate}}</h3>
          <h3 class="info">{{startDate}}</h3>
        </div>
      </div>
      <div>
        <h3 class="descriptor">{{'POLL-ONGOING.END' | translate}}</h3>
        <h3 class="info">{{endDate}}</h3>
      </div>
      <div *ngIf="!isLive" class="small-holder">
        <img class="description-icon" src="assets/election-simple.svg">
        <div>
          <h3 class="descriptor">{{'POLL-ONGOING.ELECTORS' | translate}}</h3>
          <h3 class="info-bold">{{votersCount}}</h3>
        </div>
      </div>
      <div *ngIf="!isLive" class="small-holder">
        <img class="description-icon" src="assets/tot-voters.svg">
        <div>
          <h3 class="descriptor">{{'POLL-ONGOING.VOTERS' | translate}}</h3>
          <h3 class="info-bold">{{votersVoted}}</h3>
        </div>
      </div>
      <div class="small-holder">
        <img class="description-icon" src="assets/participation.svg">
        <div>
          <h3 class="descriptor">{{'POLL-ONGOING.PARTICIPATION' | translate}}</h3>
          <h3 class="info-bold">{{participation}}%</h3>
        </div>
      </div>
      <div class="small-holder" *ngIf="!isLive">
        <img (click)="refresh()" class="refresh-icon" src="assets/refresh.svg">
      </div>
      <div class="small-holder" *ngIf="isLive" style="width: 100px">
        <img (click)="refresh()" class="refresh-icon" style="margin:auto" src="assets/refresh.svg">
      </div>
    </div>
    <div class="infos-holder" *ngIf="isLive" style="margin-top: -20px">
      <div class="small-holder" style="cursor: pointer;" (click)="sendVoterMessage('all')">
        <img class="description-icon" src="assets/election-simple-selected.svg">
        <div>
          <h3 class="descriptor">{{'POLL-FINISHED.ELECTORS' | translate}}</h3>
          <h3 class="info-bold">{{votersCount}}</h3>
        </div>
      </div>
      <div class="small-holder" style="cursor: pointer;" (click)="sendVoterMessage('participants')">
        <img class="description-icon" src="assets/election-simple-selected.svg">
        <div>
          <h3 class="descriptor">Présent(s)</h3>
          <h3 class="info-bold">{{participants}}</h3>
        </div>
      </div>
      <div class="small-holder" style="cursor: pointer;" (click)="sendVoterMessage('voted')">
        <img class="description-icon" src="assets/election-simple-selected.svg">
        <div>
          <h3 class="descriptor">{{'POLL-FINISHED.VOTERS' | translate}}</h3>
          <h3 class="info-bold">{{votersVoted}}</h3>
        </div>
      </div>
      <div class="small-holder" style="cursor: pointer;" (click)="sendVoterMessage('remaining')">
        <img class="description-icon" src="assets/election-simple-selected.svg">
        <div>
          <h3 class="descriptor">Non votant(s)</h3>
          <h3 class="info-bold">{{votersCount - votersVoted}}</h3>
        </div>
      </div>
    </div>
  </div>
</div>
